import {Params} from '@feathersjs/feathers'

import {ProviderId, ProviderSpecialization} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'providerSpecialization'

const get = async (params?: Params) =>
  feathersService.find<ProviderSpecialization>(RESOURCE, params)

export const getByProvider = async (provider: ProviderId) => {
  const parameters = {
    query: {
      provider,
    },
  }
  return get(parameters)
}

export const create = async (payload: Omit<ProviderSpecialization, 'id'>) =>
  feathersService.create<ProviderSpecialization, Omit<ProviderSpecialization, 'id'>>(
    RESOURCE,
    payload
  )

export const createMultiple = async (payload: Omit<ProviderSpecialization, 'id'>[]) =>
  payload.length > 0
    ? feathersService.createMultiple<ProviderSpecialization, Omit<ProviderSpecialization, 'id'>>(
        RESOURCE,
        payload
      )
    : Promise.resolve([])

export const remove = async (id: string) =>
  feathersService.remove<ProviderSpecialization>(RESOURCE, id)

export const removeMultiple = async (ids: string[]) => Promise.all(ids.map(id => remove(id)))
